import { namespacer } from 'helpers'

const namespace = namespacer('INDIVIDUAL_RESERVATIONS')

export const SET_USER_REGISTRATION_ERROR = namespace('SET_USER_REGISTRATION_ERROR')
export const SET_USER_REGISTRATION_SELECTED_INSTITUTION = namespace('SET_USER_REGISTRATION_SELECTED_INSTITUTION')
export const CLEAR_USER_REGISTRATION_ERROR = namespace('CLEAR_USER_REGISTRATION_ERROR')
export const LOAD_INTAKE_QUESTIONS_SUCCESS = namespace('LOAD_INTAKE_QUESTIONS_SUCCESS')
export const LOAD_INTAKE_QUESTIONS_ERROR = namespace('LOAD_INTAKE_QUESTIONS_ERROR')
